import {
	ATTRIBUTES,
	SELECTORS,
} from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
	getBackendRoute,
} from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { ModalDialog } from '@/scripts/theme/modal-dialog'

export class WaitlistForm extends UcoastEl {
	static htmlSelector = 'waitlist-form'
	form: HTMLFormElement
	submitButton: HTMLButtonElement
	emailInput: HTMLInputElement
	variantInput: HTMLInputElement
	route: string
	variant?: string
	successMessage: string
	errorMessage: string
	companyId: string
	constructor() {
		super()
		this.form = q.rs('form', this)
		this.submitButton = q.rs('[type="submit"]', this)
		this.variantInput = q.rs('[name="variant"]', this)
		this.emailInput = q.rs('[type="email"]', this)
		this.route = `${getBackendRoute()}/api/klaviyo-oos`
		this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
		this.successMessage = q.ra(this, 'data-success')
		this.errorMessage = q.ra(this, 'data-error')
		this.companyId = q.ra(this, 'data-company-id')
	}

	onSubmitHandler(event: Event) {
		console.log('onSubmitHandler')
		event.preventDefault()
		if (this.submitButton.getAttribute('aria-disabled') === 'true') return
		if (this.emailInput.value.length < 1) return

		this.submitButton.setAttribute('aria-disabled', 'true')
		this.submitButton.classList.add('loading')

		const formData = new FormData(this.form)

		const config = this.notifyMeConfig(formData)


		this.submitButton.setAttribute('aria-disabled', 'true')
		this.submitButton.setAttribute(ATTRIBUTES.loading, '')
		q.rs(SELECTORS.loadingOverlaySpinner, this).classList.remove('hidden')

		console.log(config)

		fetch(
			`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`,
			config
		)
			.then((response) => {
				console.log('WaitlistForm fetch response:', response)
				this.emailInput.value = ''
				if(response.status == 202) {
					this.submitButton.classList.add('success')
					q.rs('.waitlist__button-text', this).textContent = this.successMessage
				} else {
					this.submitButton.classList.add('error')
					q.rs('.waitlist__button-text', this).textContent = this.errorMessage
				}

				window.setTimeout(() => {
					q.rs<ModalDialog>('#WaitlistModal')?.hide()
				}, 5000)
			})
			.catch((e) => {
				console.error('WaitlistForm fetch error:', e)
				this.submitButton.classList.add('error')
			})
			.finally(() => {
				this.submitButton.removeAttribute('aria-disabled')
				this.submitButton.removeAttribute(ATTRIBUTES.loading)
				q.rs(SELECTORS.loadingOverlaySpinner, this).classList.add('hidden')

				setTimeout(() => {
					q.rs('.waitlist__button-text', this).textContent = 'Add to Waitlist'
					this.submitButton.classList.remove('success')
					this.submitButton.classList.remove('error')
				}, 5000)
			})
	}
	notifyMeConfig(body: FormData) {
		const data = {
			"data": {
			  "type": "back-in-stock-subscription",
			  "attributes": {
				"profile": {
				  "data": {
					  "type": "profile",
					  "attributes": {
						  "email": q.rfd(body, 'email'),
					  }
				  }
				},
				"channels": ["EMAIL"],
			  },
			  "relationships": {
				"variant": {
				  "data": {
					"type": "catalog-variant",
					"id": `$shopify:::$default:::${q.rfd(body, 'variant')}`
				  }
				}
			  }
			}
		}
		return {
			method: 'POST',
			headers: {
				"Content-Type": "application/json",
				"revision":"2024-06-15"
			},
			body: JSON.stringify(data),
		}
	}

}